import { Spinner } from "./Spinner";

const MODES = ["filled", "outline", "gray", "plain", "bezeled", "white"];
const SIZES = ["s", "m", "l"];

export function Button({
  children,
  mode = "filled",
  size = "m",
  before,
  after,
  stretched,
  loading,
  disabled,
  type,
  className = "",
  onClick,
  ...rest
}) {
  const classes = [
    "ui-btn",
    MODES.includes(mode) ? `ui-btn--${mode}` : "ui-btn--filled",
    SIZES.includes(size) ? `ui-btn--${size}` : "ui-btn--m",
    stretched ? "ui-btn--stretched" : "",
    loading ? "ui-btn--loading" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      className={classes}
      onClick={onClick}
      disabled={disabled || loading}
      type={type}
      {...rest}
    >
      {loading && <Spinner className="ui-btn__spinner" size="s" />}
      {before}
      {children}
      {after}
    </button>
  );
}
